/**
 * Helper for checking if a value can be considered "not empty".
 *
 * @param {*} value Value to check
 * @param {object} options Helper options
 * @param {string} [options.then] String to return when the value is not empty
 * @param {string} [options.else] String to return when the value is empty
 * @returns {*}
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default function (value: any, options: any): any {
  const isNotEmpty = value !== undefined && typeof value !== 'undefined' && value;

  if (options.hash.hasOwnProperty('then') || options.hash.hasOwnProperty('else')) {
    if (isNotEmpty) {
      if (options.hash.hasOwnProperty('then')) {
        return options.hash.then;
      }
      return null;
    } else {
      if (options.hash.hasOwnProperty('else')) {
        return options.hash.else;
      }
      return null;
    }
  } else {
    return isNotEmpty ? options.fn(this) : options.inverse(this);
  }
}
